module.exports = __webpack_public_path__ + "static/media/Equal.f8341fce.svg";